import { FaGithub, FaGlobeAmericas, FaServer } from 'react-icons/fa';
import { HiOutlineExternalLink } from 'react-icons/hi';
import hondaCBR from '../../assets/images/projects/honda-cbr.jpg';
import { BgPositionBottom, BgPositionTop } from './projectsData';

export const Project6 = () => {
  return (
    <div className="h-auto md:p-0 ">
      <div className="h-[200px] sm:h-[300px] w-auto px-3 pt-3 ">
        <div
          className="h-full details-img cursor-grab rounded-t-[3px]"
          style={{
            background: `url(${hondaCBR})`,
            backgroundPosition: 'top',
            backgroundSize: 'cover',
          }}
          onMouseOut={BgPositionBottom}
          onMouseOver={BgPositionTop}
        ></div>
      </div>
      <div className="bg-white dark:bg-light-black rounded-b-[3px]">
        <div className="px-3 pb-3 dark:text-light-blue">
          <a
            href="https://honda-bike-cbr.netlify.app"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="inline-flex items-center text-indigo-500 text-[26px] font-medium my-3">
              <h4>Honda CBR</h4>&nbsp;
              <HiOutlineExternalLink />
            </div>
          </a>
          <p>
            Honda CBR is a bike ecommerce website where you can buy bikes. You
            can find your nearest Honda showroom to buy the bike.
          </p>
          <div className="flex flex-wrap">
            <span className="bg-light-blue dark:bg-gray-600 p-2 rounded mr-2 mt-2">
              HTML
            </span>
            <span className="bg-light-blue dark:bg-gray-600 p-2 rounded mr-2 mt-2">
              CSS
            </span>
            <span className="bg-light-blue dark:bg-gray-600 p-2 rounded mr-2 mt-2">
              Bootstrap
            </span>
            <span className="bg-light-blue dark:bg-gray-600 p-2 rounded mr-2 mt-2">
              Responsive
            </span>
          </div>
          <div className="flex text-2xl mt-4 justify-between flex-wrap">
            <a
              href="https://honda-bike-cbr.netlify.app"
              className="hover:text-indigo-500 transform translate duration-500 mr-3 dark:text-white dark:hover:text-indigo-500"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="flex justify-center items-center">
                <FaGlobeAmericas
                  className="text-indigo-500"
                  title="Live Preview"
                />
                &nbsp;
                <span className="text-lg underline underline-offset-4 decoration-indigo-500">
                  Live Preview
                </span>
              </div>
            </a>
            <a
              href="https://github.com/mohammadliazul/honda-cbr-bootstrap"
              className="hover:text-indigo-500 transform translate duration-500 mr-3 dark:text-white dark:hover:text-indigo-500"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="flex justify-center items-center">
                <FaGithub className="text-indigo-500" title="Front-End Code" />
                &nbsp;
                <span className="text-lg underline underline-offset-4 decoration-indigo-500">
                  Front-End Code
                </span>
              </div>
            </a>
            <a
              href="https://github.com/mohammadliazul/honda-cbr-bootstrap"
              className="hover:text-indigo-500 transform translate duration-500 mr-3 dark:text-white dark:hover:text-indigo-500"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="flex justify-center items-center cursor-not-allowed">
                <FaServer className="text-indigo-500" title="Back-End Code" />
                &nbsp;
                <span className="text-lg underline underline-offset-4 decoration-indigo-500">
                  Back-End Code
                </span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
